import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminComponent } from './admin.component';
import { JobSchedulingComponent } from './job-scheduling/job-scheduling.component';

const routes: Routes = [
  { path: 'admin', component: AdminComponent},
  { path: '', component:JobSchedulingComponent}
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
